import firebase from 'firebase/app'
import 'firebase/database'

export default {
  namespaced: true,
  state: {
    userLogs: []
  },
  getters: {
    getUsersLogs (state) {
      return state.userLogs
    }
  },
  mutations: {
    setUserLogs (state, payload) {
      state.userLogs = payload
    }
  },
  actions: {
    async getLogsForUser ({ commit }, userId) {
      const snapshot = await firebase
        .database()
        .ref('logs')
        .orderByChild('user_uid')
        .equalTo(userId)
        .once('value')
      const userLogs = snapshot.val()
      commit('setUserLogs', userLogs)
    }
  }
}
